import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const d = {
  display: "block"
}, h = ({ size: e = 16, useVw: t, useRem: o, color: c, withColor: n, removeClassName: l, disableSSR: m, style: i, ...p }) => {
  const x = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(f, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-licaibao", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), height: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), className: l ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: l ? "" : "24px-çè´¢å®"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: l ? "" : "normal",
        clipRule: "evenodd",
        fillRule: "evenodd",
        fill: n ? r(c, 0, "#262933") : "#262933",
        datafollowfill: n ? r(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M10.896 9.183a1.56 1.56 0 0 1 2.208 0l2.274 2.274c.61.61.61 1.598 0 2.208l-2.274 2.274a1.56 1.56 0 0 1-2.208 0l-2.274-2.274a1.561 1.561 0 0 1 0-2.208l2.274-2.274Zm-1.115 3.378 2.22-2.219 2.218 2.219L12 14.78l-2.219-2.22Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M3.377 3.444a.8.8 0 0 1 .8-.8h14.791a.8.8 0 0 1 0 1.6h-1.194l3.346 4.578a7.318 7.318 0 0 1 .405 8.022l-1.47 2.506a4.06 4.06 0 0 1-3.501 2.006h-9.05a4.06 4.06 0 0 1-3.486-1.982L2.52 16.863a7.319 7.319 0 0 1 .379-8.066l3.327-4.552h-2.05a.8.8 0 0 1-.8-.8Zm4.831.8L4.191 9.74a5.719 5.719 0 0 0-.297 6.302l1.498 2.513a2.46 2.46 0 0 0 2.113 1.2h9.049a2.46 2.46 0 0 0 2.121-1.214l1.47-2.507a5.719 5.719 0 0 0-.316-6.268l-4.037-5.521H8.208Z"
        }
      )
    )
  )));
}, s = h;
export {
  s as default
};
